import { wordList, spymaster } from './game-data';
import { queryString } from "get-query-strings";
import _ from "lodash";
import * as AzureStorageTs from "azure-storage";

export type Game = {
    words: string[],
    spymaster: string[],
    masters: Player[],
    agents: Player[],
    gameId: string,
    turn: "A" | "B",
    showCards: number[]
};

export const store = {
    game: {} as Game
};
export type Player = {
    name: string,
    team: "A" | "B",
    role: "master" | "agent"
};

export function getOrCreateGame(): Promise<Game> {
    const gameId = queryString("gid");
    if (!gameId) return createGame();
    return getGame(gameId);
}
const Table = "Codenames",
    PartitionKey = "Games",
    AzureStorage: typeof AzureStorageTs = window.AzureStorage.Table,
    entGen = AzureStorage.TableUtilities.entityGenerator,
    tableSvc = AzureStorage.createTableServiceWithSas("https://digitablestorage01.table.core.windows.net", "?sv=2019-02-02&ss=t&srt=sco&sp=rwdlacu&se=2021-06-01T01:40:49Z&st=2020-04-03T17:40:49Z&spr=https&sig=qX0FYuBod4AbROroHuN9aBf0eUcGDwUA7AvEj%2Fw9Gok%3D");

function createGame(): Promise<Game> {
    const words = _.take(_.shuffle(wordList), 25),
        spymasterInstance = _.shuffle(spymaster),
        gameId = uuidv4(),
        game: Game = {
            words: words,
            spymaster: spymasterInstance,
            masters: [],
            agents: [],
            turn: "A",
            gameId,
            showCards: []
        };
    const gameEntity = {
        PartitionKey: entGen.String(PartitionKey),
        RowKey: entGen.String(gameId),
        game: JSON.stringify(game)
    };
    return new Promise(function (resolve, reject) {
        tableSvc.insertEntity(Table, gameEntity, (error, result: any, response) => {
            if (error) {
                reject(error.message);
            } else {
                resolve(game);
            }
        });
    });
}

export async function pickRole(gameId: string, role: "master" | "agent", name: string, team: "A" | "B"): Promise<{ game: Game, player: Player }> {
    const game = await getGame(gameId);
    if (role == "master" && game.masters.length == 2) throw new Error("Capi squadra al completo!");

    let player = {} as Player;
    if (role == "master") {
        player = {
            name,
            team,
            role: "master"
        }
        game.masters.push(player);
    }
    if (role == "agent") {
        player = {
            name,
            team,
            role: "agent"
        }
        game.agents.push(player);
    }

    await updateGame(game);
    return {
        game,
        player
    };
}

function updateGame(game: Game) {
    return new Promise(function (resolve, reject) {
        const updatedGame = {
            PartitionKey: entGen.String(PartitionKey),
            RowKey: entGen.String(game.gameId),
            game: JSON.stringify(game)
        };
        tableSvc.replaceEntity(Table, updatedGame, (error, result: any, response) => {
            if (error) {
                reject(error.message);
            }
            else {
                resolve(game);
            }
        });
    });
}

export function getGame(gameId: string): Promise<Game> {
    return new Promise(function (resolve, reject) {
        tableSvc.retrieveEntity(Table, PartitionKey, gameId, (error, result: any, response) => {
            if (error) {
                reject(error);
            }
            resolve(
                {
                    ...JSON.parse(result.game._),
                    gameId
                }
            );
        });
    });
}

export async function nextTurn(game: Game) {
    game.turn = game.turn == "A" ? "B" : "A";
    await updateGame(game);
}

export async function showCard(game: Game, cardIndex: number) {
    if (!_.includes(game.showCards, cardIndex)) {
        game.showCards.push(cardIndex);
        await updateGame(game)
    }
}

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
